"use strict";
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var actions = __importStar(require("./actions"));
var PageExplorerPanel_1 = __importDefault(require("./PageExplorerPanel"));
var PageExplorer = function (_a) {
    var isVisible = _a.isVisible, depth = _a.depth, currentPageId = _a.currentPageId, nodes = _a.nodes, gotoPage = _a.gotoPage, onClose = _a.onClose, navigate = _a.navigate;
    return ((isVisible && currentPageId) ? (react_1["default"].createElement(PageExplorerPanel_1["default"], { depth: depth, page: nodes[currentPageId], nodes: nodes, gotoPage: gotoPage, onClose: onClose, navigate: navigate })) : null);
};
var mapStateToProps = function (state) { return ({
    depth: state.explorer.depth,
    currentPageId: state.explorer.currentPageId,
    nodes: state.nodes,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    gotoPage: function (id, transition) { return dispatch(actions.gotoPage(id, transition)); },
    onClose: function () { return dispatch(actions.closePageExplorer()); },
}); };
exports["default"] = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PageExplorer);
